// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"950be8f3","453":"c863cbed","667":"1ac661e9","977":"d5174daf"}[chunkId] + ".chunk.js";
};